import { Facebook, Github, Twitter, Instagram } from '../AllSvg'

export const ScoialIconList = [
    { icon: Github, link: "https://github.com/RithyBondeth" },
    { icon: Facebook, link: "https://www.facebook.com/bottra.tochcambodia/" },
    { icon: Instagram, link: "https://www.instagram.com/_bondeth_/" },
    { icon: Twitter, link: "https://twitter.com/RithyBondeth" },
];